(function () {
  function initAssamTeaSliders(root) {
    if (typeof Splide === 'undefined') return;

    const sliders = (root || document).querySelectorAll('.assam-tea-slider');

    sliders.forEach(function (slider) {
      if (slider.dataset.splideInitialized === 'true') return;

      const totalSlides = slider.querySelectorAll('.splide__slide').length;
      if (totalSlides === 0) return;

      const splide = new Splide(slider, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '14px',
        pagination: false,
        arrows: totalSlides > 3,
        speed: 600,
        breakpoints: {
          989: {
            perPage: 2,
            arrows: totalSlides > 2,
            gap: '14px',
          },
          749: {
            perPage: 1,
            arrows: totalSlides > 1,
            gap: '12px',
          },
        },
      });

      splide.mount();
      slider.dataset.splideInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAssamTeaSliders(document);
    }, { once: true });
  } else {
    initAssamTeaSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAssamTeaSliders(event.target);
  });
})();
